import { createAction } from '@reduxjs/toolkit'

import { SettingsState } from './types'

export const setLanguage = createAction<SettingsState>(
  '@@settings/SET_LANGUAGE'
)
